export enum SocialMedia {
  FACEBOOK = 'facebook',
  TWITTER = 'twitter',
  INSTAGRAM = 'instagram',
  YOUTUBE = 'youtube',
  PINTEREST = 'pinterest',
  LINKEDIN = 'linkedin',
  STRAVA = 'strava',
  TIKTOK = 'tiktok',
}
